const getAuthorSlug = (authorEmail) => authorEmail.match(/^[^@]+/)[0];

export default getAuthorSlug;
